module.exports = __webpack_public_path__ + "static/media/icon-t5.4d48c124.png";